import React from 'react';
import { Spinner } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import {
  INamedObjectTypes,
  IPipelineV3ManualInterventionPreviewJson,
} from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';

const PipelineV3ManualInterventionPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: manualIntervention,
    loading,
    error,
  } = useObjectPreview<IPipelineV3ManualInterventionPreviewJson>(
    id,
    INamedObjectTypes.PipelineV3ManualIntervention,
  );
  if (error) return <span>Sorry, there was an error</span>;
  if (loading) return <Spinner />;
  return (
    <div className="pipelinev3manualintervention-preview">
      <style jsx>{`
        .pipelinev3manualintervention-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
        }

        .pipelinev3manualintervention-preview__thing-list > div {
          display: flex;
        }

        .pipelinev3manualintervention-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      {manualIntervention && (
        <>
          <div className="pipelinev3manualintervention-preview__banner">
            <span
              style={{
                fontSize: 'smaller',
                backgroundColor: 'var(--color-RemoGreen)',
                color: 'white',
                borderRadius: '14px',
                height: '28px',
                boxSizing: 'border-box',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 10px',
              }}
            >
              {manualIntervention.traitName}
            </span>
            <h3 style={{ margin: '0 5px' }}>{manualIntervention.traitName}</h3>
          </div>
          <div className="pipelinev3manualintervention-preview__body">
            <div className="pipelinev3manualintervention-preview__thing-list">
              <div>
                <strong>Lookup</strong>
                <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/lookup/${id}`}>
                  Link
                </IsomorphicLink>
              </div>
              <div>
                <strong>Entity ID</strong>
                <IsomorphicLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/lookup/${manualIntervention.entityId}`}
                >
                  {manualIntervention.entityId}
                </IsomorphicLink>
              </div>
              <div>
                <strong>Trait Name</strong>
                <span>{manualIntervention.traitName}</span>
              </div>
              {!!manualIntervention.traitParams && (
                <div>
                  <strong>Trait Params</strong>
                  <span>{JSON.stringify(manualIntervention.traitParams)}</span>
                </div>
              )}
              <div>
                <strong>Operator</strong>
                <IsomorphicLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/lookup/${manualIntervention.operatorEmail}`}
                >
                  {manualIntervention.operatorEmail}
                </IsomorphicLink>
              </div>
              <div>
                <strong>Source</strong>
                <span>{manualIntervention.source}</span>
              </div>
              <div>
                <strong>Subject Execution</strong>
                <IsomorphicLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/lookup/${manualIntervention.subjectExecution}`}
                >
                  {manualIntervention.subjectExecution}
                </IsomorphicLink>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PipelineV3ManualInterventionPreview;
